var map = {
	"./call-chat--mobile.webp": 594,
	"./call-chat.webp": 723,
	"./cursor.webp": 672,
	"./personal-account--mobile.webp": 595,
	"./personal-account.webp": 724,
	"./phone--mobile.webp": 596,
	"./phone.webp": 725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3133;